import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment'
@Component({
  selector: 'app-log-out',
  templateUrl: './log-out.component.html',
  styleUrls: ['./log-out.component.css']
})
export class LogOutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
     //if(ConstantValues.env.loginADAL == true) { 
      localStorage.clear();

      sessionStorage.clear();
      //localStorage.setItem("logOutFlag", "true");
      window.location.href = environment.logoutUrl;
    
    // }
  }

}
